export type OrgRole = 'owner' | 'admin' | 'member'

// Per Organisation von Systemadmins freischaltbare Verwaltungs-Funktionen für
// Org-Owner/-Admins (Adminbereich → Organisation → Allgemein). Ohne
// Freischaltung darf nur ein Systemadmin die jeweilige Funktion nutzen —
// Org-Admins werden dann wie einfache Mitglieder behandelt (403).
export const ORG_FEATURES = ['mcp-management', 'teams', 'slack', 'api-keys'] as const
export type OrgFeature = (typeof ORG_FEATURES)[number]

export const isOrgFeature = (value: string): value is OrgFeature =>
  (ORG_FEATURES as ReadonlyArray<string>).includes(value)

/** Anzeigenamen der freischaltbaren Funktionen (UI + Doku). */
export const ORG_FEATURE_LABELS: Record<OrgFeature, string> = {
  'mcp-management': 'MCP-Server verwalten',
  teams: 'Microsoft-Teams-Integration',
  slack: 'Slack-Integration',
  'api-keys': 'API-Schlüssel',
}

export type Organization = {
  id: string
  name: string
  createdAt: string
  // Fehlende Freischaltung (leeres Array) ⇒ nur Systemadmins dürfen die
  // jeweilige Funktion nutzen, siehe ORG_FEATURES.
  enabledFeatures: Array<OrgFeature>
}

export type OrganizationSummary = Organization & { role: OrgRole }

export type OrganizationMember = {
  userId: string
  email: string
  displayName: string
  role: OrgRole
}

// Owner und Admins verwalten ihre Organisation und erhalten zusätzlich
// Schreibzugriff auf alle darin geteilten Inhalte (siehe
// scopeGrantsAdminAccess in models/assignment.ts).
export const isOrgAdminRole = (role: OrgRole): boolean =>
  role === 'owner' || role === 'admin'

export const canManageOrgMembers = (role: OrgRole): boolean => isOrgAdminRole(role)
